import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProgramKpiPage } from './program-kpi';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

@NgModule({
  declarations: [
    ProgramKpiPage,
  ],
  imports: [
    IonicPageModule.forChild(ProgramKpiPage),
    NgxDatatableModule
  ],
})
export class ProgramKpiPageModule {}



// WEBPACK FOOTER //
// ./src/pages/program-kpi/program-kpi.module.ts